import styled from 'styled-components'
import Base from '../base/index'

const Subtitle = styled(Base.withComponent('h3'))`
    font-size:${props => props.fontSize ?`${props.fontSize};` : '2rem'};
`

export default Subtitle